const THEME_STYLESHEET_ID = 'theme-stylesheet';

function getThemeHref(isRTL) {
  return `${process.env.PUBLIC_URL}/css/theme${isRTL ? '-rtl' : ''}.css`;
}

function ensureThemeStylesheet() {
  const existingLink = document.getElementById(THEME_STYLESHEET_ID);
  if (existingLink) {
    return existingLink;
  }

  const link = document.createElement('link');
  link.id = THEME_STYLESHEET_ID;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  document.getElementsByTagName('head')[0].appendChild(link);
  return link;
}

const toggleRTL = isRTL => {
  const themeLink = ensureThemeStylesheet();
  themeLink.href = getThemeHref(isRTL);
  document.getElementsByTagName('html')[0].setAttribute('dir', `${isRTL ? 'rtl' : 'ltr'}`);
};

export default toggleRTL;
